import { useId } from 'react'

interface StarRatingProps {
  label: string
  value: number | null
  onChange: (v: number | null) => void
  disabled?: boolean
  /** Optional helper text below the row. */
  hint?: string
}

/** 5-Sterne-Rating für Probearbeiter-Bewertung. Leerer Klick = null. */
export function StarRating({ label, value, onChange, disabled, hint }: StarRatingProps) {
  const id = useId()
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="block text-[11px] font-medium uppercase tracking-wider text-on-surface-variant">
        {label}
      </label>
      <div id={id} className="flex items-center gap-1.5" role="radiogroup" aria-label={label}>
        {[1, 2, 3, 4, 5].map(n => {
          const filled = value != null && n <= value
          return (
            <button
              key={n}
              type="button"
              role="radio"
              aria-checked={value === n}
              disabled={disabled}
              onClick={() => onChange(value === n ? null : n)}
              className={`text-2xl leading-none transition-transform ${
                disabled ? 'opacity-50 cursor-not-allowed' : 'hover:scale-110'
              } ${filled ? 'text-amber-400' : 'text-on-surface-variant/40'}`}
              title={`${n} von 5`}
            >
              {filled ? '★' : '☆'}
            </button>
          )
        })}
        {value != null && (
          <button
            type="button"
            disabled={disabled}
            onClick={() => onChange(null)}
            className="ml-2 text-[11px] text-on-surface-variant hover:text-on-surface underline"
          >
            zurücksetzen
          </button>
        )}
      </div>
      {hint && <p className="text-[11px] text-on-surface-variant">{hint}</p>}
    </div>
  )
}
